const envVars = import.meta.env as Record<string, string | undefined>;

export const ROLE_GROUP_USER = envVars.VITE_ROLE_GROUP_USER ?? envVars.ROLE_GROUP_USER ?? 'group_user';
export const ROLE_GROUP_ADMIN = envVars.VITE_ROLE_GROUP_ADMIN ?? envVars.ROLE_GROUP_ADMIN ?? 'group_admin';

export const ROLE_LABEL_KEY_MAP: Record<string, string> = {
  [ROLE_GROUP_USER]: 'roles.groupUser',
  [ROLE_GROUP_ADMIN]: 'roles.groupAdmin',
};
